import FilterInput from 'components/styled/FilterInput'
import * as React from 'react'
import ResultSelect from 'components/styled/ResultSelect'
import { FilterLiveStyled } from 'components/styled/FilterLiveStyled'

const CardValidationFilters = [
  <FilterInput key="correlation_id" label="Correlation Id" source="correlation_id" />,
  <FilterLiveStyled key="context.card_validation.card_token" label="Card Token" source="context.card_validation.card_token" />,
  <FilterLiveStyled key="context.customer.msisdn" label="MSISDN" source="context.customer.msisdn" />,
  <FilterLiveStyled key="context.customer.document" label="Document" source="context.customer.document" />,
  <FilterInput key="payment_id" label="Payment Id" source="payment_id" />,
  <ResultSelect key="result" label="Result" source="result" />,
  <FilterInput key="id" label="Id" source="id" />
]

export default CardValidationFilters
